// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/uploadN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/images/add_template.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/images/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/images/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/images/zoom-in.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/images/zoom-out.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#magnificationToolbarItems {
    position: absolute;
    bottom: 66px;
    display: block;
    width: auto;
    transform: rotate(90deg);
    right: 7.5px;
    z-index: 1001;
   }

   #magnificationToolbar {
     background: transparent;
  }

   .e-pv-zoom-out-sample {
    transform: rotate(-90deg);
   }

   div#magnificationToolbar.e-toolbar .e-toolbar-items {
    background: transparent;
    padding: 2px 3px 2px 2px;
   }

   #magnificationToolbar.e-toolbar .e-tbar-btn {
    border-radius: 50%;
    min-height: 30px;
    min-width: 30px;
    border: 0.5px solid #c8c8c8;
   }

  #topToolbar {
    top: 0px;
    z-index: 1001;
 }

  .e-pv-current-page-number {
    width: 46px;
    height: 28px;
    text-align: center;
  }

  .material .e-pv-current-page-number {
    border-width: 1px;
  }

  .e-pv-icons {
    font-family: "e-pv-icons";
    font-style: normal;
    font-feature-settings: normal;
    font-variant: normal;
    font-weight: normal;
    line-height: 1;
    text-transform: none;
  }

  .e-pdf-toolbar .e-icons::before {
    font-family: 'e-pv-icons';
   }

  .e-pv-icon-search::before {
    font-family: 'e-pv-icons';
    font-size: 12px;
  }

  #topToolbar .e-pv-download-document-icon::before {
    padding-left: 4px;
    content: '\\ed05';
  }

  #topToolbar .e-pv-print-document-icon::before {
    padding-left: 1px;
    content: '\\ed08';
   }

  .e-pv-previous-page-navigation-icon::before {
      content: '\\ed01';
    }

   .e-pv-next-page-navigation-icon::before {
     content: '\\ed02';
   }

   .e-pv-zoom-out-sample::before {
     content: '\\ed03';
    }

    .e-pv-zoom-in-icon::before {
    content: '\\ed04';
    }

   .e-pv-fit-page::before {
    content: '\\ed12';
   }
   .e-pv-open-document-icon::before {
    content: '\\ed13';
 }

@font-face {
    font-family: "e-pv-icons";
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

#fileUpload{
  display: none;
}

#container.e-pv-viewer-main-container {
  background-color: white;
}
#container .e-pv-viewer-container {
  background-color: white;
}

/* #container_formdesigner_close{
  display: none!important;
} */

.custIcons button#file_Open, .custIcons button#chooseTemplates{
  color: #666666;
  font-family: Manrope !important;
  font-size: 15px;
  font-weight: 500;
  min-height: 39px;
  margin: 0;
  padding: 5px;
}
.custIcons button#file_Open .e-tbar-btn-text, .custIcons button#chooseTemplates .e-tbar-btn-text{ 
  color: #666666;
  font-family: Manrope !important;
  font-size: 15px;
  font-weight: 500; 
  padding-left: 10px;
}
.custIcons .e-tbar-btn:hover, .custIcons .e-tbar-btn:focus {
  background-color: transparent !important;
  border: 0;
  outline:0;
}
.custIcons button#file_Open::before, .custIcons button#chooseTemplates::before{
  content: ' ';
  width: 19px;
  height: 21px;
}
.custIcons button#file_Open::before{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.custIcons button#chooseTemplates::before{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.custIcons .e-pv-next-page-navigation-icon::before, .custIcons .e-pv-previous-page-navigation-icon::before{
  font-family: inherit !important;
  height: 21px;
  width: 17px;
  display: inline-block;
}
.custIcons #next_page .e-pv-next-page-navigation-icon::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;

}
.custIcons #previous_page .e-pv-previous-page-navigation-icon::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
}
.custIcons #previous_page,  .custIcons #next_page{
  min-height: 39px;
  min-width: 30px;
  margin: 0;
  padding: 5px;
}
.custIcons #previous_page .e-btn-icon, .custIcons #next_page .e-btn-icon {
  margin: 0;
  min-width: auto;
  width: auto;
  line-height: 17px;
}
.custIcons input#currentPage {
  border: 1px solid #DFDFDF;
  border-radius: 5px;
  font-size: 15px;
  color: #949494;
  min-height: 39px
}
.custIcons #zoom_in, .custIcons #zoom_out { min-width: 30px; }

.custIcons #zoom_in .e-btn-icon::before, .custIcons #zoom_out .e-btn-icon::before{
  font-family: inherit !important;
  height: 21px;
  width: 21px;
  display: inline-block;
}

.custIcons #zoom_in .e-btn-icon::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
}
.custIcons #zoom_out .e-btn-icon::before{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
}
.custIcons #zoom_out .e-pv-zoom-out-sample {
  transform: rotate(0deg);
}

#container.e-pv-viewer-main-container {
  background-color: white;
}
#container .e-pv-viewer-container {
  /*background-color: white;*/
  border-radius: 0px;
  /* border: 1px dashed var(--Active-State, #3A68D8);
  background: #FBFBFB;
  left: 46px !important;
  height: 100% !important;
  right: 0 !important;
  width: 95.7% !important; */
}

.doct-upload-div .e-pdfviewer .e-pv-viewer-container {
  border: 0;
}

.custIcons #previous_page,  .custIcons #zoom_in{
  min-height: 39px;
  min-width: 30px;
  margin: 0;
  padding: 5px;
}

/* .custIcons button#form_designer{
  background: url(/src/assets/images/form-43.svg);
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
 height: 30px;
width: 24px;
  margin-bottom: 4px;}*/



  /*.bttns-div-center {
    
    left: 20%;
    right: 0;
    top: 70%;
    bottom: 0;
    margin: auto;
}*/

button.btn.btn-default.center-bttns {
  color: #666;
  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.align-div {
  position: absolute;
  left: 45%;
  right: 50%;
  /* transform: translate(-50%, -50%); */
  width: 100%;
  top: 50%;
}
.center-div{position: relative;}

.center-bttns{border-radius: 10px !important;
  border: 1px solid var(--light-gray-outline, #DFDFDF) !important;
  background: var(--White, #FFF);
  height: 50px;
}

.center-div-top-text{color: var(--Avenu-Black, #302B3A);
  margin-left: 10px;
  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;}

 .upload-imags {
    width: 20px;
    margin: 0px 10px 5px 0px;
    /* padding-left: 0px; */
    /* margin-left: 0px; */
}
.e-pdfviewer .e-pv-bookmark-button {
  display: none;
  }`, "",{"version":3,"sources":["webpack://./src/views/Onboarding/DocumentUpload.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,aAAa;GACd;;GAEA;KACE,uBAAuB;EAC1B;;GAEC;IACC,yBAAyB;GAC1B;;GAEA;IACC,uBAAuB;IACvB,wBAAwB;GACzB;;GAEA;IACC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;GAC5B;;EAED;IACE,QAAQ;IACR,aAAa;CAChB;;EAEC;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,6BAAoB;IAApB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;GAC1B;;EAED;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;GACjB;;EAED;MACI,gBAAgB;IAClB;;GAED;KACE,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;IACjB;;IAEA;IACA,gBAAgB;IAChB;;GAED;IACC,gBAAgB;GACjB;GACA;IACC,gBAAgB;CACnB;;AAED;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,+DAAssG;AAC1sG;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,SAAS;EACT,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,mDAA+C;EAC/C,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,mDAAoD;EACpD,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mDAAqD;EACrD,uCAAuC;EACvC,iCAAiC;EACjC,6CAA6C;;AAE/C;AACA;EACE,mDAAoD;EACpD,uCAAuC;EACvC,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;AACF;AACA,4CAA4C,eAAe,EAAE;;AAE7D;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mDAA+C;EAC/C,uCAAuC;EACvC,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,mDAAgD;EAChD,uCAAuC;EACvC,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB;;;;;4BAK0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;;;;;;;uBAOuB;;;;EAIrB;;;;;;;EAOA;;AAEF;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,WAAW;EACX,QAAQ;AACV;AACA,YAAY,kBAAkB,CAAC;;AAE/B,cAAc,8BAA8B;EAC1C,+DAA+D;EAC/D,8BAA8B;EAC9B,YAAY;AACd;;AAEA,qBAAqB,kCAAkC;EACrD,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,CAAC;;CAErB;IACG,WAAW;IACX,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;EACE,aAAa;EACb","sourcesContent":["#magnificationToolbarItems {\n    position: absolute;\n    bottom: 66px;\n    display: block;\n    width: auto;\n    transform: rotate(90deg);\n    right: 7.5px;\n    z-index: 1001;\n   }\n\n   #magnificationToolbar {\n     background: transparent;\n  }\n\n   .e-pv-zoom-out-sample {\n    transform: rotate(-90deg);\n   }\n\n   div#magnificationToolbar.e-toolbar .e-toolbar-items {\n    background: transparent;\n    padding: 2px 3px 2px 2px;\n   }\n\n   #magnificationToolbar.e-toolbar .e-tbar-btn {\n    border-radius: 50%;\n    min-height: 30px;\n    min-width: 30px;\n    border: 0.5px solid #c8c8c8;\n   }\n\n  #topToolbar {\n    top: 0px;\n    z-index: 1001;\n }\n\n  .e-pv-current-page-number {\n    width: 46px;\n    height: 28px;\n    text-align: center;\n  }\n\n  .material .e-pv-current-page-number {\n    border-width: 1px;\n  }\n\n  .e-pv-icons {\n    font-family: \"e-pv-icons\";\n    font-style: normal;\n    font-variant: normal;\n    font-weight: normal;\n    line-height: 1;\n    text-transform: none;\n  }\n\n  .e-pdf-toolbar .e-icons::before {\n    font-family: 'e-pv-icons';\n   }\n\n  .e-pv-icon-search::before {\n    font-family: 'e-pv-icons';\n    font-size: 12px;\n  }\n\n  #topToolbar .e-pv-download-document-icon::before {\n    padding-left: 4px;\n    content: '\\ed05';\n  }\n\n  #topToolbar .e-pv-print-document-icon::before {\n    padding-left: 1px;\n    content: '\\ed08';\n   }\n\n  .e-pv-previous-page-navigation-icon::before {\n      content: '\\ed01';\n    }\n\n   .e-pv-next-page-navigation-icon::before {\n     content: '\\ed02';\n   }\n\n   .e-pv-zoom-out-sample::before {\n     content: '\\ed03';\n    }\n\n    .e-pv-zoom-in-icon::before {\n    content: '\\ed04';\n    }\n\n   .e-pv-fit-page::before {\n    content: '\\ed12';\n   }\n   .e-pv-open-document-icon::before {\n    content: '\\ed13';\n }\n\n@font-face {\n    font-family: \"e-pv-icons\";\n    font-style: normal;\n    font-weight: normal;\n    src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype');\n}\n\n#fileUpload{\n  display: none;\n}\n\n#container.e-pv-viewer-main-container {\n  background-color: white;\n}\n#container .e-pv-viewer-container {\n  background-color: white;\n}\n\n/* #container_formdesigner_close{\n  display: none!important;\n} */\n\n.custIcons button#file_Open, .custIcons button#chooseTemplates{\n  color: #666666;\n  font-family: Manrope !important;\n  font-size: 15px;\n  font-weight: 500;\n  min-height: 39px;\n  margin: 0;\n  padding: 5px;\n}\n.custIcons button#file_Open .e-tbar-btn-text, .custIcons button#chooseTemplates .e-tbar-btn-text{ \n  color: #666666;\n  font-family: Manrope !important;\n  font-size: 15px;\n  font-weight: 500; \n  padding-left: 10px;\n}\n.custIcons .e-tbar-btn:hover, .custIcons .e-tbar-btn:focus {\n  background-color: transparent !important;\n  border: 0;\n  outline:0;\n}\n.custIcons button#file_Open::before, .custIcons button#chooseTemplates::before{\n  content: ' ';\n  width: 19px;\n  height: 21px;\n}\n.custIcons button#file_Open::before{\n  background: url(/src/assets/images/uploadN.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n}\n.custIcons button#chooseTemplates::before{\n  background: url(/src/assets/images/add_template.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n}\n.custIcons .e-pv-next-page-navigation-icon::before, .custIcons .e-pv-previous-page-navigation-icon::before{\n  font-family: inherit !important;\n  height: 21px;\n  width: 17px;\n  display: inline-block;\n}\n.custIcons #next_page .e-pv-next-page-navigation-icon::before {\n  background: url(/src/assets/images/chevron-right.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center center !important;\n\n}\n.custIcons #previous_page .e-pv-previous-page-navigation-icon::before {\n  background: url(/src/assets/images/chevron-left.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center center !important;\n}\n.custIcons #previous_page,  .custIcons #next_page{\n  min-height: 39px;\n  min-width: 30px;\n  margin: 0;\n  padding: 5px;\n}\n.custIcons #previous_page .e-btn-icon, .custIcons #next_page .e-btn-icon {\n  margin: 0;\n  min-width: auto;\n  width: auto;\n  line-height: 17px;\n}\n.custIcons input#currentPage {\n  border: 1px solid #DFDFDF;\n  border-radius: 5px;\n  font-size: 15px;\n  color: #949494;\n  min-height: 39px\n}\n.custIcons #zoom_in, .custIcons #zoom_out { min-width: 30px; }\n\n.custIcons #zoom_in .e-btn-icon::before, .custIcons #zoom_out .e-btn-icon::before{\n  font-family: inherit !important;\n  height: 21px;\n  width: 21px;\n  display: inline-block;\n}\n\n.custIcons #zoom_in .e-btn-icon::before {\n  background: url(/src/assets/images/zoom-in.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center center !important;\n}\n.custIcons #zoom_out .e-btn-icon::before{\n  background: url(/src/assets/images/zoom-out.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center center !important;\n}\n.custIcons #zoom_out .e-pv-zoom-out-sample {\n  transform: rotate(0deg);\n}\n\n#container.e-pv-viewer-main-container {\n  background-color: white;\n}\n#container .e-pv-viewer-container {\n  /*background-color: white;*/\n  border-radius: 0px;\n  /* border: 1px dashed var(--Active-State, #3A68D8);\n  background: #FBFBFB;\n  left: 46px !important;\n  height: 100% !important;\n  right: 0 !important;\n  width: 95.7% !important; */\n}\n\n.doct-upload-div .e-pdfviewer .e-pv-viewer-container {\n  border: 0;\n}\n\n.custIcons #previous_page,  .custIcons #zoom_in{\n  min-height: 39px;\n  min-width: 30px;\n  margin: 0;\n  padding: 5px;\n}\n\n/* .custIcons button#form_designer{\n  background: url(/src/assets/images/form-43.svg);\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  background-position: center center !important;\n height: 30px;\nwidth: 24px;\n  margin-bottom: 4px;}*/\n\n\n\n  /*.bttns-div-center {\n    \n    left: 20%;\n    right: 0;\n    top: 70%;\n    bottom: 0;\n    margin: auto;\n}*/\n\nbutton.btn.btn-default.center-bttns {\n  color: #666;\n  font-family: Manrope;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.align-div {\n  position: absolute;\n  left: 45%;\n  right: 50%;\n  /* transform: translate(-50%, -50%); */\n  width: 100%;\n  top: 50%;\n}\n.center-div{position: relative;}\n\n.center-bttns{border-radius: 10px !important;\n  border: 1px solid var(--light-gray-outline, #DFDFDF) !important;\n  background: var(--White, #FFF);\n  height: 50px;\n}\n\n.center-div-top-text{color: var(--Avenu-Black, #302B3A);\n  margin-left: 10px;\n  font-family: Manrope;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;}\n\n .upload-imags {\n    width: 20px;\n    margin: 0px 10px 5px 0px;\n    /* padding-left: 0px; */\n    /* margin-left: 0px; */\n}\n.e-pdfviewer .e-pv-bookmark-button {\n  display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
